import { render, staticRenderFns } from "./TrainingPlanSummary.vue?vue&type=template&id=64d0594c&scoped=true&"
import script from "./TrainingPlanSummary.vue?vue&type=script&lang=js&"
export * from "./TrainingPlanSummary.vue?vue&type=script&lang=js&"
import style0 from "./TrainingPlanSummary.vue?vue&type=style&index=0&id=64d0594c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d0594c",
  null
  
)

export default component.exports